import { Switch, Form, Input, Flex, Radio } from "antd"
import { AlignCenterOutlined, AlignLeftOutlined, AlignRightOutlined } from "@ant-design/icons"
import { useState, useEffect } from "react"
import { useTranslation } from 'react-i18next';

const DividerForm = ({ formValues, form }) => {
    const { t } = useTranslation();

    // useEffect(() => {
    //     if(formValues.text) {
    //         form.setFields({"textAlignment": formValues.textAlignment || "center"})
    //     }
    // },[formValues.text])


    return (
        <>

            <Form.Item name="text" label={t('Text')} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            {
                formValues && formValues.text &&
                <>
                    <Form.Item label="" name="label">
                        <Input placeholder={t('Enter label')} />
                    </Form.Item>
                    <Flex align="center" justify="space-between" className="alignment-wrapper">
                        <Form.Item label={t('Text Alignment')} name="textAlignment">
                            <Radio.Group>
                                <Radio.Button value="left"><AlignLeftOutlined /></Radio.Button>
                                <Radio.Button value="center"><AlignCenterOutlined /></Radio.Button>
                                <Radio.Button value="right"><AlignRightOutlined /></Radio.Button>
                            </Radio.Group>
                        </Form.Item>

                    </Flex>
                </>
            }

            <Form.Item name="dashed" label={t('Dashed')} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>
            <Form.Item name="hideInitially" label={t('Hide Initially')} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>
        </>
    )
}

export default DividerForm